import type { FuelEconomyData, VehicleTab } from '../types';

export const getIsFuelSavingCardState = (state: any): boolean => {
    return state.fuelSaving?.isFuelSavingCardState ?? false;
};

export const getVehicleTabs = (state: any): VehicleTab[] => {
    return state.fuelSaving?.vehicleTabs ?? [];
};

export const getFuelEconomyData = (state: any): FuelEconomyData | null => {
    return state.fuelSaving?.fuelEconomyData ?? null;
};
